// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/
module.exports = require('entities/maps/entities.json');



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/markdown-it/lib/common/entities.js
// module id = RoGF
// module chunks = 0